import React from 'react'
import SurveyPopup from '../../survey/SurveyPopup'

const HvIdentity2Popup = ({ close, ...props }) => 
  <SurveyPopup close={close} surveyType="IDENTITY_2" title="Hv Identity 2" {...props} />


export default HvIdentity2Popup
